export const getAccessToken = () => {
    return localStorage.getItem('access-token')
} 